import FetchHelper from '../helpers/fetch_helper';
import Config from '../config/config';

let { inlineManualEnabled } = Config;

const PageDispatcher = {
  setLastEvent(e) {
    e.persist();
    const { screenX, screenY, clientX, clientY, currentTarget } = e;
    const rect = e.currentTarget.getBoundingClientRect();
    const lastEvent = {
      clientX,
      clientY,
      rect,
      screenX,
      screenY,
      target: currentTarget,
    };
    this.setStoreVal('lastEvent', lastEvent);
  },

  setView(data) {
    const currentView = this.getStoreVal('view');
    this.setStoreValWithCheck('previousView', currentView);
    this.setStoreValWithCheck('view', data);
  },

  setReduxVar({ key, value }) {
    this.setStoreVal(key, value);
  },

  upsertView(data) {
    const currentView = this.getStoreVal('view');
    this.setStoreValWithCheck('previousView', currentView);
    this.setStoreValWithCheck('view', { ...currentView, ...data });
  },

  generatingDocs(bool) {
    if (bool) {
      this.incrementLock('generatingDocs');
    } else {
      this.decrementLock('generatingDocs');
    }
  },

  setRoute(data) {
    if (inlineManualEnabled && window.inline_manual_player && window.inlineManualTracking.name) {
      /* eslint-disable no-undef */
      inline_manual_player.update();
      /* eslint-enable no-undef */
    }
    if (data && data.includes('/login') && !window.location.href.includes('at=')) {
      this.router.setRoute(`${data}?at=${window.location.href}`);
    } else {
      this.router.setRoute(data);
    }
  },

  async submitPasswordChangeForm({ currentPassword, confirmedPassword }) {
    return FetchHelper.fetchJson('users/password/change', {
      headers: {
        accept: 'application/json',
      },
      method: 'POST',
      body: { currentPassword, confirmedPassword },
    });
  },

  async submitEmailChangeForm({ email }) {
    return FetchHelper.fetchJson('users/username/change', {
      headers: {
        accept: 'application/json',
      },
      method: 'POST',
      body: { email },
    });
  },

  requestModals(data) {
    this.setStoreVal('modalRequests', data);
  },

  closeModal(data) {
    this.setStoreVal('modalRequests', { ...data, modalAction: 'close' });
  },

  clearModalRequests() {
    this.setStoreVal('modalRequests', null);
  },
};
export default PageDispatcher;
